import Image, { type StaticImageData } from 'next/image'

import EllipsisIcon from '@/legacy-src/components/header/EllipsisIcon'
import Icon from '@/legacy-src/components/icons/Icon'
import { cn } from '@/legacy-src/lib/utils'

import { Heading } from '@/src/domains/design-system/components/Heading'
import { Text } from '@/src/domains/design-system/components/Text'
import { HeaderBasicNavigationLink } from '@/src/domains/header/components/Header/HeaderBasicNavigationLink'

const bg = ['text-yellow-500', 'text-blue-500', 'text-pink-500']

export interface HeaderNavigationBusinessUIProps {
  title: string
  image: string | StaticImageData
  links: { href: string; iconName: string; title: string }[]
}

export const HeaderNavigationBusinessUI = ({ links = [], title, image }: HeaderNavigationBusinessUIProps) => (
  <div className="relative">
    <div className="flex flex-col items-center laptop:flex-row laptop:flex-nowrap">
      <Image
        priority
        height={330}
        width={368}
        alt=""
        src={image}
        className="mr-[60px] hidden rounded-[40px] laptop:block"
      />

      <div className="w-full flex-1">
        {title ? (
          <Heading element="h3" variant="xl" className="truncate">
            {title}
          </Heading>
        ) : null}
        <ul className="m-0 mt-5 grid list-none grid-cols-1 gap-5 p-0 laptop:mt-8 laptop:grid-cols-2 laptop:gap-8">
          {links.map((link, index) => {
            const bgColor = bg[index % bg.length]
            return (
              <li key={link.href}>
                <Text asChild variant="lg" weight="bold">
                  <HeaderBasicNavigationLink
                    href={link.href}
                    className="group flex items-center no-underline hover:text-peach-500 hover:no-underline"
                  >
                    <EllipsisIcon color="currentColor" className={cn('mr-4 shrink-0', bgColor)}>
                      <Icon icon={link.iconName} size="md" width={30} height={30} className="text-petrol-500" />
                    </EllipsisIcon>
                    <span>{link.title}</span>
                  </HeaderBasicNavigationLink>
                </Text>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  </div>
)
